import getWindow from "../../utils/window";
import { setEvents } from "../events";

export const setPricingIconLoad = () => {
  if (!getWindow()) {
    return;
  }
  setEvents({ events: ["event332"], trackingName: "pageLoad" });
};
